<template>
  <div class="container">
    <!-- Priemera Tabla-->

    <!-- <div v-if="!readOnly" class="div-button">
      <b-row v-if="userPermissions" class="Checkbox-form">
        <b-form-checkbox
          style="display:flex;   justify-content: flex-end; "
          v-model="checked"
          name="check-button"
          switch
        >
          <span class="span" v-if="checked"> No Aplica</span>
          <span class="span" v-else>Aplica</span>
        </b-form-checkbox>
      </b-row>
    </div> -->

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleOne }}
        </h6>
      </div>
      <Maintable
        :porcentajeIngreso="porcentajeIngreso"
        :efectividad="efectividad"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleTwo }}
        </h6>
      </div>
      <MainTablesTwo
        :ceseRetiro="ceseRetiro"
        :porcentajeRecuperacion="porcentajeRecuperacion"
        :valor="valor"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleThree }}
        </h6>
      </div>
      <MainTableThree
        :funcionarioAscendidos="funcionarioAscendidos"
        :funcionariosRecontratados="funcionariosRecontratados"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleFour }}
        </h6>
      </div>
      <MainTableFour
        :porcentajeFuncionariosCapacitados="porcentajeFuncionariosCapacitados"
        :promedioAnualHoras="promedioAnualHoras"
        :porcentajeActividades="porcentajeActividades"
        :becasOrtogadas="becasOrtogadas"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleFive }}
        </h6>
      </div>
      <MainTableFive
        :diasNoLaboradoTipoOne="diasNoLaboradoTipoOne"
        :diasNoLaboradoOtroTipo="diasNoLaboradoOtroTipo"
        :permisoNoRemunerado="permisoNoRemunerado"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleSix }}
        </h6>
      </div>
      <MainTableSix
        :horasExtraordinarias="horasExtraordinarias"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleSeven }}
        </h6>
      </div>
      <MainTableSeven
        :distribuccionPersonalL="distribuccionPersonalL"
        :retroalimentacionDesempenio="retroalimentacionDesempenio"
        :readOnly="readOnly"
      />
    </section>

    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleEight }}
        </h6>
      </div>
      <MianTableEight :politicaGestion="politicaGestion" :readOnly="readOnly" />
    </section>
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleNine }}
        </h6>
      </div>
      <MainTableNine
        :ingresoContrata="ingresoContrata"
        :honorariosRegularizado="honorariosRegularizado"
        :porcentajeIngreso="porcentajeIngreso"
        :readOnly="readOnly"
      />
    </section>

    <div v-if="!readOnly" class="div-button">
      <button @click="guardarBorrador" class="button" v-if="userPermissions">
        Guardar Borrador
      </button>

      <button class="button" @click="guardarYFinalizar" v-if="userPermission">
        Guardar y Finalizar
      </button>
    </div>
  </div>
</template>

<script>
import Maintable from "./tables/MainTable";
import MainTablesTwo from "./tables/MainTablesTwo";
import MainTableThree from "./tables/MainTableThree";
import MainTableFour from "./tables/MainTableFour";
import MainTableFive from "../components/tables/MainTableFive";
import MainTableSix from "../components/tables/MainTableSix";
import MainTableSeven from "../components/tables/MainTableSeven";
import MianTableEight from "../components/tables/MianTableEight";
import MainTableNine from "../components/tables/MainTableNine";
import axios from "axios";
import { showAlert } from "../../../components/tools/utils";
import Swal from "sweetalert2";
import { mapState } from "vuex";

export default {
  props: ["permiso", "valor"],
  components: {
    Maintable,
    MainTablesTwo,
    MainTableThree,
    MainTableFour,
    MainTableFive,
    MainTableSix,
    MainTableSeven,
    MianTableEight,
    MainTableNine,
  },

  data() {
    return {
      titleOne: "1. Reclutamiento y Selección",
      titleTwo: "2. Rotación de Personal",
      titleThree: "3. Grado de Movilidad en el Servicio",
      titleFour: "4. Capacitación y Perfeccionamiento del Personal",
      titleFive: "5. Días no Trabajados",
      titleSix: "6. Grado de Extensión de la Jornada",
      titleSeven: "7. Evaluación del Desempeño",
      titleEight: "8. Política de Gestión de Personas",
      titleNine: "9. Regularización de Honorarios",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      anio: `${process.env.VUE_APP_ANIO}`,
      servicio: `${this.$route.params.idServicio}`,
      item: null,
      tableStore: null,
      datosTable: null,
      userPermission: true,
      userPermissions: true,
      datosUser: null,
      readOnly: true,
      checked: false,
      porcentajeIngreso: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      efectividad: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      // porcentajeEgresos: {
      //   inputOne: "",
      //   inputTwo: "",
      //   inputThree: "",
      //   inputFour: "",
      //   inputFive: "",
      //   inputSix: "",
      // },
      ceseRetiro: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
        inputSeven: "",
        inputEight: "",
        inputNine: "",
        inputTen: "",
        inputEleven: "",
        inputTwelve: "",
        inputThirteen: "",
        inputFourteen: "",
        inputFifteen: "",
      },
      porcentajeRecuperacion: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      funcionarioAscendidos: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      funcionariosRecontratados: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      porcentajeFuncionariosCapacitados: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      promedioAnualHoras: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      porcentajeActividades: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      becasOrtogadas: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      diasNoLaboradoTipoOne: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      diasNoLaboradoOtroTipo: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      permisoNoRemunerado: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      horasExtraordinarias: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      distribuccionPersonalL: {
        uno: "",
        tres: "",
        cinco: "",
        //
        siete: "",
        nueve: "",
        once: "",
        //
        trece: "",
        quince: "",
        diecisiete: "",
        //
        diecinueve: "",
        veintiuno: "",
        veintitres: "",
        //
        veinticinco: "",
        veintisiete: "",
        veintinueve: "",
      },
      retroalimentacionDesempenio: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
      },
      politicaGestion: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
      },
      ingresoContrata: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
      honorariosRegularizado: {
        inputOne: "",
        inputTwo: "",
        inputThree: "",
        inputFour: "",
        inputFive: "",
        inputSix: "",
      },
    };
  },

  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    builData: function(type) {
      return {
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
        data: {
          aplica: this.checked,
          porcentajeIngresos: this.porcentajeIngreso,
          efectividad: this.efectividad,

          ceseRetiro: this.ceseRetiro,
          porcentajeRecuperacion: this.porcentajeRecuperacion,
          funcionarioAscendidos: this.funcionarioAscendidos,
          funcionariosRecontratados: this.funcionariosRecontratados,
          porcentajeFuncionariosCapacitados: this
            .porcentajeFuncionariosCapacitados,
          promedioAnualHoras: this.promedioAnualHoras,
          porcentajeActividades: this.porcentajeActividades,
          becasOrtogadas: this.becasOrtogadas,
          diasNoLaboradoTipoOne: this.diasNoLaboradoTipoOne,
          diasNoLaboradoOtroTipo: this.diasNoLaboradoOtroTipo,
          permisoNoRemunerado: this.permisoNoRemunerado,
          horasExtraordinarias: this.horasExtraordinarias,
          distribuccionPersonalL: this.distribuccionPersonalL,
          retroalimentacionDesempenio: this.retroalimentacionDesempenio,
          politicaGestion: this.politicaGestion,
          ingresoContrata: this.ingresoContrata,

          honorariosRegularizado: this.honorariosRegularizado,
        },
        elaboracion: type,
        nombre: "recursos_humanos",
      };
    },

    guardarBorrador: async function() {
      try {
        const toSend = this.builData("borrador");

        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        this.obtener();
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            anio: process.env.VUE_APP_ANIO,
            idServicio: this.$route.params.idServicio,
            data: {
              porcentajeIngreso: this.porcentajeIngreso,
              efectividad: this.efectividad,
              aplica: this.checked,
              ceseRetiro: this.ceseRetiro,
              porcentajeRecuperacion: this.porcentajeRecuperacion,
              funcionarioAscendidos: this.funcionarioAscendidos,
              funcionariosRecontratados: this.funcionariosRecontratados,
              porcentajeFuncionariosCapacitados: this
                .porcentajeFuncionariosCapacitados,
              promedioAnualHoras: this.promedioAnualHoras,
              porcentajeActividades: this.porcentajeActividades,
              becasOrtogadas: this.becasOrtogadas,
              diasNoLaboradoTipoOne: this.diasNoLaboradoTipoOne,
              diasNoLaboradoOtroTipo: this.diasNoLaboradoOtroTipo,
              permisoNoRemunerado: this.permisoNoRemunerado,
              horasExtraordinarias: this.horasExtraordinarias,
              distribuccionPersonalL: this.distribuccionPersonalL,
              retroalimentacionDesempenio: this.retroalimentacionDesempenio,
              politicaGestion: this.politicaGestion,
              ingresoContrata: this.ingresoContrata,

              honorariosRegularizado: this.honorariosRegularizado,
            },
            elaboracion: "borrador",
            nombre: "recursos_humanos",
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          this.obtener();
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },

    obtener: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=recursos_humanos`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (res.data.info.porcentajeIngreso) {
          this.porcentajeIngreso = res.data.info.porcentajeIngreso;
        }
        console.log(res.data.info.porcentajeIngreso);
        if (res.data.info.efectividad) {
          this.efectividad = res.data.info.efectividad;
        }

        if (res.data.info.ceseRetiro) {
          this.ceseRetiro = res.data.info.ceseRetiro;
        }
        if (res.data.info.porcentajeRecuperacion) {
          this.porcentajeRecuperacion = res.data.info.porcentajeRecuperacion;
        }
        if (res.data.info.funcionarioAscendidos) {
          this.funcionarioAscendidos = res.data.info.funcionarioAscendidos;
        }
        if (res.data.info.funcionariosRecontratados) {
          this.funcionariosRecontratados =
            res.data.info.funcionariosRecontratados;
        }
        if (res.data.info.porcentajeFuncionariosCapacitados) {
          this.porcentajeFuncionariosCapacitados =
            res.data.info.porcentajeFuncionariosCapacitados;
        }
        if (res.data.info.promedioAnualHoras) {
          this.promedioAnualHoras = res.data.info.promedioAnualHoras;
        }
        if (res.data.info.porcentajeActividades) {
          this.porcentajeActividades = res.data.info.porcentajeActividades;
        }
        if (res.data.info.becasOrtogadas) {
          this.becasOrtogadas = res.data.info.becasOrtogadas;
        }

        if (res.data.info.diasNoLaboradoTipoOne) {
          this.diasNoLaboradoTipoOne = res.data.info.diasNoLaboradoTipoOne;
        }
        if (res.data.info.diasNoLaboradoOtroTipo) {
          this.diasNoLaboradoOtroTipo = res.data.info.diasNoLaboradoOtroTipo;
        }

        if (res.data.info.permisoNoRemunerado) {
          this.permisoNoRemunerado = res.data.info.permisoNoRemunerado;
        }

        if (res.data.info.horasExtraordinarias) {
          this.horasExtraordinarias = res.data.info.horasExtraordinarias;
        }

        if (res.data.info.distribuccionPersonalL) {
          this.distribuccionPersonalL = res.data.info.distribuccionPersonalL;
        }

        if (res.data.info.retroalimentacionDesempenio) {
          this.retroalimentacionDesempenio =
            res.data.info.retroalimentacionDesempenio;
        }

        if (res.data.info.politicaGestion) {
          this.politicaGestion = res.data.info.politicaGestion;
        }

        if (res.data.info.ingresoContrata) {
          this.ingresoContrata = res.data.info.ingresoContrata;
        }

        if (res.data.info.honorariosRegularizado) {
          this.honorariosRegularizado = res.data.info.honorariosRegularizado;
        }
      } catch (error) {
        console.log(error);
      }
    },
    guardarYFinalizar: async function() {
      const toSend = this.builData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                anio: process.env.VUE_APP_ANIO,
                idServicio: this.$route.params.idServicio,
                data: {
                  porcentajeIngresos: this.porcentajeIngreso,
                  efectividad: this.efectividad,
                  aplica: this.checked,
                  ceseRetiro: this.ceseRetiro,
                  porcentajeRecuperacion: this.porcentajeRecuperacion,
                  funcionarioAscendidos: this.funcionarioAscendidos,
                  funcionariosRecontratados: this.funcionariosRecontratados,
                  porcentajeFuncionariosCapacitados: this
                    .porcentajeFuncionariosCapacitados,
                  promedioAnualHoras: this.promedioAnualHoras,
                  porcentajeActividades: this.porcentajeActividades,
                  becasOrtogadas: this.becasOrtogadas,
                  diasNoLaboradoTipoOne: this.diasNoLaboradoTipoOne,
                  diasNoLaboradoOtroTipo: this.diasNoLaboradoOtroTipo,
                  permisoNoRemunerado: this.permisoNoRemunerado,
                  horasExtraordinarias: this.horasExtraordinarias,
                  distribuccionPersonalL: this.distribuccionPersonalL,
                  retroalimentacionDesempenio: this.retroalimentacionDesempenio,
                  politicaGestion: this.politicaGestion,
                  ingresoContrata: this.ingresoContrata,

                  honorariosRegularizado: this.honorariosRegularizado,
                },
                elaboracion: "finalizado",
                nombre: "recursos_humanos",
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Documento Guardado ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            console.log(error);
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },
    obtenerRelacionUsuarioServicios() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 5) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4
      ) {
        this.readOnly = false;
      }
    },
  },

  mounted() {
    this.obtener();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
    this.obtenerRelacionUsuarioServicios();
  },
};
</script>

<style scoped>
.head-data {
  background-color: #cfcccc;
}
.title {
  padding: 1rem;
}
/* .container-graphics {
  display: flex;
  justify-content: center;
  align-items: center;
} */

.button {
  border: none;
  cursor: pointer;
  width: 20%;
  height: 21%;
  margin-bottom: 20px;
  background: #0b5ed7;
  color: #fff;
  border-radius: 20px;
  margin-right: 20px;
}

.div-button {
  display: flex;
  justify-content: center;
}
</style>
